import { removeCookie, setNewCookie, getValueCookie } from "../services/cookieService";
import { closeAllPages, openPage } from "./changeVisibility";
import { v4 as uuidv4 } from "uuid";
import { getInformationWithDataGlobalSales } from "../services/CABE";

export function CloseAllPages() {
  closeAllPages();
}

export async function OpenCompanyDashBoard() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'CompanyDashBoard');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  var boton = document.getElementById("catalogueOfCompanyActioner");
  boton.click();
  openPage("App");
  openPage("CompanyDashBoard");
}

export async function GetNumberOfOrders(SalesPerson) {
  const respuesta = await getInformationWithDataGlobalSales("/Sales/get", {
    SalespersonNo: SalesPerson,
  });
  if (respuesta.SalesOrderList) {
    return respuesta.SalesOrderList.length;
  }
  return 0;
}

export async function OpenLobby() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'Lobby');
  
  // V1
  // if (window.location.pathname !== '/') {
  //   setTimeout(() => {
  //     window.location.href = '/';
  //   }, 100); // 100ms
  //   return;
  // }

  CloseAllPages();

  // V1
  // openPage("App");
  // openPage("GeneralPages");
  // openPage("Lobby");
  // var boton = document.getElementById("LobbyInfoCharge");
  // if (boton) {
  //   boton.click();
  // }

  const typeUser = getValueCookie('TypeUser');
  // Redirect to dashboard V2 
  if (typeUser !== '1' && typeUser !== '12') {
    // Sales person redirect
    window.location.assign("/sales/dashboard");
  } else {
    // Administrator redirect
    window.location.assign("/admin/dashboard");
  }
}

export function OpenRecovery() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'Recovery');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("Recovery");
}

export function PriceMargin() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'MargenesPrecio');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("MargenesPrecio");
}

export async function OpenCycleInventory() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'CycleInventory');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  var boton = document.getElementById("actionatorCycleInventory");
  boton.click();
  openPage("App");
  openPage("GeneralPages");
  openPage("CycleInventory");
}

export function OpenCycleInventoryGraph() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'CycleInventoryGraph');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("CycleInventoryGraph");
}

export function OpenInventoryPromotionsView() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'PromotionsView');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("PromotionsView");
}

export function InactiveProducts() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'InactiveProducts');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("InactiveProducts");
}

export async function OpenKPIGraph() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'KPIGraph');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  var boton = document.getElementById("actionatorKPI");
  boton.click();
  openPage("App");
  openPage("GeneralPages");
  openPage("KPIGraph");
}

export function OpenLogin() {
  // No se requiere redirección aquí, ya que es la ruta base
  
  CloseAllPages();
  openPage("login");
}

export function OpenInventory() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'Inventory');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("Inventory");
}

export function OpenPikingSystem() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'PikingSystem');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("PikingSystem");
}

export function OpenWasteSystem() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'WasteSystem');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("WasteSystem");
}

export function OpenGeneralPages(page) {
  // Set cookie for redirection
  setNewCookie('redirectTo', page);
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage(page);
}

export function OpenSalesOrder() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'SalesOrder');
  if (window.location.pathname !== '/') {
    // Redirigir
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("SalesOrder");
}

export function OpenPortalSalesOrder() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'PortalSalesOrder');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("PortalSalesOrder");
}

export async function OpenPurchaseOrder() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'PurchaseOrder');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  var button = document.getElementById("vendorsFromPurchaseOrder");
  button.click();
  openPage("App");
  openPage("GeneralPages");
  openPage("PurchaseOrder");
}

export function OpenNewCustomer() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'NewCustomer');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("NewCustomer");
}

export function OpenInvoices() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'Invoices');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("Invoices");
}

export function OpenAccountsReceivable() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'AccountsReceivable');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("AccountsReceivable");
}

export function OpenInvoicesReport(){
  // Set cookie for redirection
  setNewCookie('redirectTo', 'OpenInvoicesReport');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("OpenInvoicesReport");
}

export function OpenShortsReport() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'ShortsReport');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("ShortsReport");
}

export function OpenMOHReport() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'MOHReport');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("MOHReport");
}

export function OpenSalesReport() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'SalesReport');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("SalesReport");
}

export function OpenVendorReport() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'VendorReport');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("VendorReport");
}

export function OpenPurchaseProcessReport() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'PurchaseProcessReport');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("PurchaseProcessReport");
}

export function OpenActualInventoryReport() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'ActualInventoryReport');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("ActualInventoryReport");
}

export function OpenHistoryInventoryReport() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'HistoryInventoryReport');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("HistoryInventoryReport");
}

export function OpenDesignPage() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'HistoryInventoryReport');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("DesignPage");
}

export function OpenAutomaticPOPage() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'AutomaticPOPage');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("AutomaticPOPage");
}

export function OpenReturnPurchaseOrder() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'ReturnPurchaseOrder');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("ReturnPurchaseOrder");
}

export function OpenPriceMarginProdLine() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'PriceMarginProdLine');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("PriceMarginProdLine");
}

export function OpenNewProductsToInclude() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'NewProductsToInclude');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("NewProductsToInclude");
}

export function OpenPaymentRecord() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'PaymentRecord');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("PaymentRecord");
}

export function OpenScanningReport() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'ScanningReport');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("ScanningReport");
}

export function OpenTrackingReport() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'TrackingReport');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("TrackingReport");
}

export function OpenWeightPerTravelReport() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'WeightPerTravelReport');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("WeightPerTravelReport");
}

export function OpenHistoryPurchaseOrdersReport() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'HistoryPurchaseOrdersReport');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("HistoryPurchaseOrdersReport");
}

export function OpenSalesOrdersReport() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'SalesOrdersReport');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("SalesOrderReport");
}

export function OpenVendorPriceChangeReport() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'VendorPriceChangeReport');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("VendorPriceChangeReport");
}

export function OpenSpoilageReport() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'SpoilageReport');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("SpoilageReport");
}
export function SalesTracker() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'SalesTracker');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("SalesTracker");
}

export function OpenRouteSales() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'RouteSales');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("RouteSalesReport");
}

export function OpenCalculateMargins() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'CalculateMargins');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("CalculateMargin");
}

export function OpenInventoryOverstock() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'InventoryOverstock');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("InventoryOverstock");
}

export function OpenGeneralMarginPrices() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'GeneralMarginPrices');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("GeneralMarginPrices");
}

export function OpenUsersManagement() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'UsersManagement');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("UsersManagement");
}

export function OpenLogs() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'Logs');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  openPage("App");
  openPage("GeneralPages");
  openPage("LogsPage")
}

export async function OpenPurchasing() {
  // Set cookie for redirection
  setNewCookie('redirectTo', 'Purchasing');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // 100ms
    return;
  }

  CloseAllPages();
  var boton = document.getElementById("actionatorPurchasing");
  boton.click();
  openPage("App");
  openPage("GeneralPages");
  openPage("Purchasing");
}

export function CloseCompanySession() {
  removeCookie("Company");
  removeCookie("SubCompanyId");
  removeCookie("TypeUser");
  removeCookie("SalesPerson");
  removeCookie("CompanyId");
  removeCookie("phone");
  removeCookie("warehouse");
  removeCookie("website");
  removeCookie("address");
  removeCookie("fullName");
  removeCookie("DocumentsLogo");
  removeCookie("CompanyLogo");
  removeCookie("TotalOrders");
  removeCookie('apiPrefix');
  window.localStorage.setItem("session", uuidv4());
  // Select comapany V1
  // OpenCompanyDashBoard();

  // Select comapany V2
  window.location.href = '/select-company';
}

export default {
  OpenLogin,
  CloseAllPages,
  OpenCycleInventory,
  OpenLobby,
  OpenCompanyDashBoard,
  OpenCycleInventoryGraph,
  CloseCompanySession,
  OpenSalesOrder,
  OpenInvoices,
  OpenAccountsReceivable,
  OpenInvoicesReport,
  OpenShortsReport,
  OpenMOHReport,
  OpenSalesReport,
  OpenVendorReport,
  OpenPurchaseProcessReport,
  OpenDesignPage,
  OpenActualInventoryReport,
  OpenHistoryInventoryReport,
  OpenAutomaticPOPage,
  OpenNewProductsToInclude,
  OpenPaymentRecord,
  OpenScanningReport,
  OpenTrackingReport,
  OpenHistoryPurchaseOrdersReport,
  OpenWeightPerTravelReport,
  OpenReturnPurchaseOrder,
  OpenPurchasing,
  OpenLogs,
};
